export function trimStringOrEmpty(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/** Trims non-string values to empty; returns null (not '') when the trimmed result is empty. */
export function nonEmptyTrimmed(value: unknown): string | null {
  const trimmed = trimStringOrEmpty(value);
  return trimmed !== '' ? trimmed : null;
}

/** API spot ids are positive numbers or non-empty strings; numeric 0 is treated as unset. */
export function isValidNonEmptySpotRef(id: string | number | null | undefined): boolean {
  if (id === null || id === undefined) {
    return false;
  }
  if (typeof id === 'number') {
    return Number.isFinite(id) && id > 0;
  }
  return id.trim() !== '';
}

export function spotRefToTrimmedString(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'number' && isValidNonEmptySpotRef(value)) {
    return String(value);
  }
  return '';
}

/**
 * When `value` is an array, returns the single trimmed name only if there is exactly one entry;
 * otherwise returns empty (multi-seat / unknown shape is not collapsed to a guess).
 */
export function getSingleSpotNameOrEmpty(value: unknown): string {
  if (Array.isArray(value)) {
    if (value.length !== 1) return '';
    return trimStringOrEmpty(value[0]);
  }
  return trimStringOrEmpty(value);
}
